export const TOGGLE_PRICE_CHECKBOX_TEXT = 'Enable Price Label';
export const TOGGLE_PRICE_HELP_DESCRIPTION =
  "Enable this setting in order to enter non-numeric prices. For example: 'market price' or '$100+'.";
